import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { PotreePageContainer } from 'pages/pointClouds/PotreePage'
import { z } from 'zod'

const pointCloudQuerySchema = z.object({
  cameraPos: z.string().optional(), // Expecting "x,y,z"
  cameraTarget: z.string().optional(), // Expecting "x,y,z"
})

export const Route = createFileRoute(
  '/point-cloud/$siteID/$pointCloudOrSceneID'
)({
  component: PotreePageContainer,
  validateSearch: zodValidator(pointCloudQuerySchema),
})
